import React from 'react';
import { GlossaryTermModel, SlideObject } from '@/components/admin/SlideShow/types';
import HintButtonSnippet from '@/components/common/HtmlElements/HintButton/Snippet';
import HintButton from '@/components/common/HtmlElements/HintButton';
import IHintButton from '@/components/interfaces/graphql/HtmlElement/HintButton';
import useSlideShowContext from '@/components/admin/SlideShow/stores/useSlideShowContext';

interface VocabListProps {
  linkedVocab: GlossaryTermModel[];
  slideObject: SlideObject;
}

const VocabList = ({ linkedVocab = [], slideObject }: VocabListProps) => {
  const isPresentMode = useSlideShowContext(state => state.isPresentMode);
  const locale = useSlideShowContext(state => state.locale);

  const HintComponent = isPresentMode ? HintButton : HintButtonSnippet;

  return (
    <div className="tw-h-full">
      <ul className="tw-list-disc tw-p-8 tw-leading-6">
        {linkedVocab.map((lv, index) => {
          const term = lv?.glossary_term;
          if (!term) return null;

          const hintButton: IHintButton = {
            data: { autoHide: true },
            htmlEn: term.definition_en,
            htmlEs: term.definition_es,
            id: index,
            imageModels: [],
            modelId: slideObject.id,
            modelType: 'SlideObject',
            type: 'HintButton',
          };

          const termHtml = locale === 'en' ? term.term_en : term.term_es;

          return (
            <li key={term.id || index}>
              <span dangerouslySetInnerHTML={{ __html: `${termHtml}&nbsp;` }} />
              <HintComponent hintButton={hintButton} />
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default VocabList;
